<template>
  <div class="pa-badge-controls">
    <div class="content-field">
      <button
       class="button plus-button"
       :class="plusButtonClass"
       :disabled="isDisabledPlusButton"
       @click.prevent="handleClickPlusButton"
      >
        <font-awesome-icon :icon="plusButtonIconName" />
      </button>

      <ul class="pa-badges">
        <li v-for="badge in podMessage.badges" :key="badge.slug">
          <PAItemBadgeBanner
           :badge="badge.item"
           :count="badge.count"
           @click="handleClickBadgeBanner(badge)"
          />
        </li>
      </ul>

      <transition name="pa-simple-fade">
        <div class="pa-badge-selector" v-if="isOpenBadgeSelector">
          <template v-if="badgeItems !== 0">
            <ul class="badge-selector" v-if="hasBadgeItem">
              <template v-for="badge in badgeItems">
                <li v-if="badge.quantity !== 0" :key="badge.item.id">
                  <div class="pa-badge-circle" @click.prevent="handleClickBadgeIcon(badge.item)">
                    <PAItemBadgeIcon :item="badge.item" />
                  </div>
                </li>
              </template>
            </ul>
          </template>
          <div v-else class="loader"></div>
        </div>
      </transition>
    </div>

    <div class="overlay-field"
     v-if="isOpenOverlay"
     @click.prevent="handleClickOverlay"
    ></div>
  </div>
</template>

<script>
import PAItemBadgeBanner from '@/components/Parts/PAItemBadgeBanner/PAItemBadgeBanner.vue'
import PAItemBadgeIcon from '@/components/Parts/PAItemBadgeIcon/PAItemBadgeIcon.vue'
import {GetCharacterItemStore} from '@/graphql/queries/CharacterItemStore.graphql'
import {GetMessageData} from '@/graphql/queries/ConnectionPod.graphql'
import {AddBadgeToPodMessage} from '@/graphql/mutations/Pod.graphql'
import {GetModalAlertInfomations} from '@/graphql/queries/Character.graphql'

import PABadgeControlMixins from '@/mixins/PABadgeControlMixins.js'

export default {
  props : {
    podMessage : {
      default: null
    }
  },

  mixins : [
    PABadgeControlMixins
  ],

  components : {
    PAItemBadgeBanner,
    PAItemBadgeIcon
  },
  
  data(){
    return {
      isDisabledPlusButton  : false,

      plusButtonClass       : {
        'plus-button-disabled' : false
      },

      plusButtonIconName    : 'plus',

      isOpenOverlay         : false,

      isOpenBadgeSelector   : false,

      hasBadgeItem          : false,
      badgeItems            : [],
    };
  },

  apollo : {
    characterItemStoreList : {
      query : GetCharacterItemStore,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    modalAlertInfomations : {
      query: GetModalAlertInfomations
    },
  },

  watch : {
    characterItemStoreList : {
      handler(data){
        this.badgeItems = [];

        for(let store of data){
          if(store.item.type !== 'badge') continue;
          
          this.badgeItems.push(store);
        }
      },
      deep: true
    },

    badgeItems : {
      handler(data){
        let hasSomeBadge = false;

        for(let i of data){
          if(i.quantity > 0){
            hasSomeBadge = true;
            break;
          }
        }

        this.hasBadgeItem = hasSomeBadge;
      },
      deep: true
    },

    isOpenBadgeSelector(value){
      if(value === true){
        this.plusButtonIconName = 'chevron-up';
      }else{
        this.plusButtonIconName = 'plus';
      }

      this.isOpenOverlay = value;
    },

    hasBadgeItem : {
      handler(value){
        this.isDisabledPlusButton = !value;
      },
      immediate: true
    },

    isDisabledPlusButton : {
      handler(value){
        this.plusButtonClass['plus-button-disabled'] = value;
      },
      immediate: true
    }
  },
  
  methods : {
    handleClickPlusButton(){
      if(!this.hasBadgeItem) return;
      
      this.isOpenBadgeSelector = !this.isOpenBadgeSelector;
    },

    handleClickOverlay(){
      this.isOpenBadgeSelector = !this.isOpenBadgeSelector;
    },

    executeAddBadge(badgeData){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : AddBadgeToPodMessage,
          variables : {
            podMessageId  : this.podMessage.id,
            badgeSlug     : badgeData.slug,
          },
          update    : (store, {data:{AddBadgeToPodMessage:{podMessage}}}) => {
            store.writeQuery({
              query     : GetMessageData,
              variables : {
                id  : podMessage.id
              },
              data      : {
                podMessage : podMessage
              }
            });

            this.$apollo.queries.characterItemStoreList.refetch();
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          if(typeof errorSet.first !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;使用するアイテムが不足しています。',
              status      : 'error',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    handleClickBadgeIcon(badgeData){
      this.isOpenBadgeSelector = false;

      const itemStockData = this.getItemStockData({
        badgeData : badgeData,
        quantity  : 1
      });

      let isDisabledSubmitButton = false;
      let lineMessage            = null;
      if( (itemStockData.total - itemStockData.quantity) < 0 ){
        isDisabledSubmitButton = true;
        lineMessage            = 'アイテムが不足しています。';
      }
      
      this.$store.dispatch({
        type          : 'itemUseModal/updateOpenModal',

        value         : true,

        templateName  : 'addBadgeToPodMessage',

        meta          : {
          itemName      : badgeData.name,
          itemImageSlug : badgeData.slug,
          quantity      : itemStockData.quantity,
          total         : itemStockData.total,
          remain        : itemStockData.remain,
        },

        handleSubmitFunction : async () => {
          this.$store.dispatch({
            type            : 'itemUseModal/updateOpenModal',
            isSubmitLoading : true,
          });

          await this.UXWaiting(1000);

          // ここでバッジを付ける
          await this.executeAddBadge(badgeData);

          this.$store.dispatch({
            type            : 'itemUseModal/updateOpenModal',
            value           : false,
            isSubmitLoading : false
          });

          // ポイントアップのモーダル処理
          this.$apollo.queries.modalAlertInfomations.refetch();
        },

        handleCancelFunction : () => {
          this.$store.dispatch({
            type  : 'itemUseModal/updateOpenModal',
            value : false,
          });
        },

        isDisabledSubmimtbutton : isDisabledSubmitButton,
        lineMessage             : lineMessage
      });
    },
    
    getItemStockData(payload){
      const results = {
        quantity  : payload.quantity,
        total     : 0,
        remain    : 0,
      };

      for(let store of this.characterItemStoreList){
        if(store.item.slug !== payload.badgeData.slug) continue;
        
        results.total  = store.quantity;
        results.remain = (results.total - payload.quantity);

        if(results.remain < 0){
          results.remain = 0;
        }
      }

      return results;
    },

    handleClickBadgeBanner(badge){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['pod_message_badge_character_list_id']        = this.podMessage.id;
      newUrlQuery['pod_message_badge_character_list_badge_id']  = badge.item.id;
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    }
  }
}
</script>

<style lang="scss">
.pa-badge-controls{
  .pa-badge-circle{
    display: block;
    background-color: #B39571;
    width:22px;
    height: 22px;
    border-radius: 50%;
    margin:0;
    padding:0;
    text-align: center;

    .pa-item-icon{
      line-height: 22px;
      font-size: 14px;
    }
  }

  .content-field{
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    margin:0 .5rem;

    .plus-button{
      margin:0;
      padding:0;
      display: block;
      width:22px;
      height:22px;
      border-radius:50%;
      
      border:0;
      background-color: #BB9D79;
      color: #7D593C;
      
      text-align: center;
      
      font-weight: bold;
      
      font-size:.7rem;
      line-height:.7rem;
      
      user-select:none;
      
      &:focus {
        outline: none;
        box-shadow:none;
      }

      &-disabled{
        background-color: #BB9D79;
        color: #977E60;
      }
    }

    .pa-badges{
      display: flex;
      flex-flow: row-reverse;
      margin:0;
      padding:0;
      
      li{
        margin:0 .3rem 0 0;
      }
    }

    .pa-badge-selector{
      position: absolute;
      top:23px;
      right:5px;
      padding:.3rem .4rem;
      border-radius: 20px;
      background-color: #C19C6E;
      z-index:2;
      display: block;

      ul.badge-selector{
        display: flex;
        flex-flow: row;
        margin:0;
        padding:0;
        line-height: 1;

        li{
          margin:0 .4rem 0 0;
          padding:0;

          &:last-child{
            margin-right: 0;
          }
        }
      }

      .loader{
        border: 1.5px solid #B58A68;
        border-right-color: transparent;
        border-top-color: transparent;
      }
    }
  }

  .overlay-field{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: block;
    cursor: default;
    content: " ";
    background: transparent;
  }
}
</style>